import React from 'react'

const Required = ({ msg, required, block, notEmail, notValidated }) => {
  return (
    <div className="config-required">
      {
        required &&
        <>
          {block && <><p className="required">{msg}</p></>}
          {notValidated && <><p className="required">Dato no coincide</p></>}
          {notEmail && <><p className="required">Correo inválido</p></>}
        </>
      }
    </div>
  )
}

export default Required 